import apiClient from "./client";
import { unwrapApiResponse } from "../utils/apiError";

export const authAPI = {
  loginWithPassword: async ({ phone, password }) => {
    const response = await apiClient.post("/teacher/login", { phone, password });
    return unwrapApiResponse(response);
  },

  requestOtp: async ({ phone }) => {
    const response = await apiClient.post("/teacher/otp/request", { phone });
    return unwrapApiResponse(response);
  },

  verifyOtp: async ({ phone, code }) => {
    const response = await apiClient.post("/teacher/otp/verify", { phone, code });
    return unwrapApiResponse(response);
  },
};
